import { useAxios } from "@/compositions";
import type { AxiosRequestConfig } from "axios";

const baseURL = `${import.meta.env.VITE_API_BASE_URL}/v1/`;

const { post, get, put, remove, patch } = useAxios(baseURL);

const crudFactory = (model: string) => {
  return {
    createOne: async <T>(data: any, config?: AxiosRequestConfig): Promise<T> => {
      return await post<T>(model, data, config);
    },

    getAll: async <T>(config?: AxiosRequestConfig, defaultAxiosResponse: boolean = true): Promise<T> => {
      return await get<T>(model, config, defaultAxiosResponse);
    },

    getOne: async <T>(id: string, config?: AxiosRequestConfig): Promise<T> => {
      return await get<T>(`${model}/${id}`, config);
    },

    updateOne: async <T>(id: string, data: any, config?: AxiosRequestConfig): Promise<T> => {
      return await put<T>(`${model}/${id}`, data, config);
    },

    updateAll: async <T>(data: any, config?: AxiosRequestConfig): Promise<T> => {
      return await put<T>(`${model}`, data, config);
    },

    patch: async <T>(subpath?: string, data?: any, config?: AxiosRequestConfig): Promise<T> => {
      const path = subpath ? `${model}/${subpath}` : model;
      return await patch<T>(path, data, config);
    },

    patchOne: async <T>(id: string, data: any, config?: AxiosRequestConfig): Promise<T> => {
      return await patch<T>(`${model}/${id}`, data, config);
    },

    deleteOne: async (id: string, config?: AxiosRequestConfig): Promise<null> => {
      return await remove(`${model}/${id}`, config);
    },

    post: async <T>(subpath?: string, data?: any, config?: AxiosRequestConfig): Promise<T> => {
      const path = subpath ? `${model}/${subpath}` : model;
      return await post<T>(path, data, config);
    },

    putOne: async <T>(id: string, data: any, config?: AxiosRequestConfig, subpath?: string): Promise<T> => {
      const path = subpath ? `${model}/${id}/${subpath}` : `${model}/${id}`;
      return await put<T>(path, data, config);
    }
  };
};

export default crudFactory;
